import { render, staticRenderFns } from "./StepCheckClient.vue?vue&type=template&id=3bcdbb3c&scoped=true"
import script from "./StepCheckClient.vue?vue&type=script&lang=js"
export * from "./StepCheckClient.vue?vue&type=script&lang=js"
import style0 from "./StepCheckClient.vue?vue&type=style&index=0&id=3bcdbb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdbb3c",
  null
  
)

export default component.exports